// Shared SQL sniffing for the manual change feed: which table (if any) does a
// statement mutate? Matches the leading verb after optional whitespace/comments,
// extracts the table name (optionally schema-qualified, optionally
// quoted/backticked). The table name is what change listeners compare against
// `getTableConfig().name`.
const MUTATING_TABLE_REGEX =
  /^\s*(?:\/\*[\s\S]*?\*\/\s*|--[^\n]*\n\s*)*(?:insert(?:\s+or\s+\w+)?\s+into|update(?:\s+or\s+\w+)?|delete\s+from|replace\s+into)\s+(?:(?:"([^"]+)"|`([^`]+)`|\[([^\]]+)\]|(\w+))\s*\.\s*)?(?:"([^"]+)"|`([^`]+)`|\[([^\]]+)\]|(\w+))/i;

export function extractMutatedTable(sql: string): string | null {
  const match = MUTATING_TABLE_REGEX.exec(sql);
  if (match === null) {
    return null;
  }
  return match[5] ?? match[6] ?? match[7] ?? match[8] ?? null;
}

/**
 * Split a multi-statement SQL script into individual statements for per-table
 * emission. Intentionally naive (splits on `;`): scripts passed to `execAsync`
 * in this codebase are migrations/PRAGMAs without string literals containing
 * semicolons; a mis-split only mis-parses a fragment that then fails the
 * mutating-verb regex — a missed emission at worst, never a crash.
 */
export function splitSqlStatements(sql: string): string[] {
  return sql
    .split(";")
    .map((statement) => statement.trim())
    .filter((statement) => statement.length > 0);
}
